/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class ServiceUnavailableError extends errors.TruvityError {
    constructor(body: Truvity.ServiceUnavailableProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'ServiceUnavailableError',
            statusCode: 503,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, ServiceUnavailableError.prototype);
    }
}
